<template>
    <div
        class="tw-bg-opacity-10 tw-mb-6 tw-flex tw-items-start tw-gap-6 tw-rounded-lg tw-bg-[#38bdf81f] tw-px-8 tw-py-6"
    >
        <img
            class="tw-mt-1 tw-size-14 tw-object-contain"
            src="@/assets/class-booking-success.png"
            alt="Class Booked Success"
        />
        <div class="tw-flex tw-flex-col">
            <div class="tw-mb-1 tw-text-base tw-font-semibold tw-text-gray-900">
                Your Family's Class is Booked! 🎉
            </div>
            <div class="tw-mb-0.5 tw-text-sm tw-text-gray-700">
                Your family members are all set—get ready to enjoy the class
                together!
            </div>
            <div class="tw-text-xs tw-text-gray-400">
                To cancel, please select and cancel from each family member's
                card individually.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SuccessBookingBanner',
}
</script>
